/*
    ********************************************************************************
        Configuring AppInsight
    ********************************************************************************
*/

import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';
import { appSettings } from '../../appSettings';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';
import React from 'react';

//@ts-ignore
const browserHistory = createBrowserHistory({ basename: '' });

// Get the domain for Fed Auth so AppInsights knows to exclude it.
const fedAuthDomain = appSettings?.OIDC_PROVIDER?.replace('https://', '')
    ?.replace('http://', '')
    ?.replace('/', '') as string;

const appInsightsReactPlugin = new ReactPlugin();
const appInsightsInitializer = new ApplicationInsights({
    config: {
        connectionString: appSettings.APPINSIGHTS_CONNECTIONSTRING,
        enableAutoRouteTracking: true,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,

        /* 
           Application Insights can automatically track dependencies and correlate requests between 
           different components of your application. This is useful for understanding the flow of requests 
           and identifying performance bottlenecks.
           To enable this correlation tracking, Application Insights injects correlation headers like 
           Request-Id and Request-Context into outgoing HTTP requests. These headers help tie together 
           requests made by different parts of your application.
           Sometimes, there may be domains or services in your application that you don't want to include in 
           this correlation tracking. For example, you might have third-party services or external domains 
           that should be excluded because you don't have control over their behavior, or including them in 
           correlation tracking might lead to noise in your telemetry data.
           correlationHeaderExcludedDomains List domains that can't access the request-id, and 
           request-context headers. 
        */
        correlationHeaderExcludedDomains: [fedAuthDomain],
        extensions: [appInsightsReactPlugin],
        extensionConfig: {
            [appInsightsReactPlugin.identifier]: { history: browserHistory },
        },
    },
});

appInsightsInitializer.loadAppInsights();

export const appInsightsClient = appInsightsInitializer;

export const withAppInsightsTracking = (Component: React.ComponentType) =>
    withAITracking(appInsightsReactPlugin, Component);
